@use "../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../styles/Colors.scss" as Colors;

.empty-cell {
	color: Colors.$col-greyFontLight;
	font-size: Constants.$val-fontSizeXSmall;
}

.billingTypeIndicator {
	margin-right: Constants.$val-spacing-s;
}

.billableStatusOptions {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-s;
}

.resetJobWorkSummaryButton {
	margin-left: Constants.$val-spacing-s;
}
